import { LanguageContext } from '@dapperlabs/core-fe';
import { useAnalytics } from '@dapperlabs/react-analytics';
import { getCookie } from 'cookies-next';
import { GetServerSidePropsContext } from 'next';
import Head from 'src/general/components/Head/Head';
import { useLanguage } from 'src/general/hooks/useLanguage';
import { useTranslation } from 'src/lib/translations';
import { AboutPageContent } from 'src/modules/AboutPageContent';
import { getStaticAboutPageContent } from 'src/modules/AboutPageContent/staticContent';

interface AboutPageProps {
  content: {
    aboutPageData: any;
  };
}

const AboutPage = ({ content }: AboutPageProps) => {
  const { t } = useTranslation();
  const { aboutPageData } = content;
  const { track } = useAnalytics();
  const { handleLanguage } = useLanguage();

  const trackHandler = (event, props) => {
    if (event.event_name) {
      track(event.event_name, { item_label: event.item_label });
      return;
    }
    track(event, props);
  };

  return (
    <LanguageContext.Provider value={handleLanguage}>
      <Head
        description={t('Head.AboutPage.Description')}
        subtitle={t('Head.AboutPage.Subtitle')}
        title={t('Head.AboutPage.Title')}
      />
      {aboutPageData && (
        <AboutPageContent {...aboutPageData} trackHandler={trackHandler} />
      )}
    </LanguageContext.Provider>
  );
};

export async function getServerSideProps({
  req,
  res,
}: GetServerSidePropsContext) {
  const locale = (getCookie('language', { req, res }) as string) || 'en-US';
  const aboutPageData = getStaticAboutPageContent(locale);

  return {
    props: {
      content: {
        aboutPageData,
      },
    },
  };
}

export default AboutPage;
